var map = {
	"./Group1.svg": "bf77",
	"./Group2.svg": "573d",
	"./attachment-icon.svg": "ea98",
	"./brightness-high.svg": "f5d7",
	"./brightness-low.svg": "b830",
	"./close.svg": "6fdc",
	"./comment-text-active.svg": "8961",
	"./comment-text.svg": "d540",
	"./copy-icon.svg": "2376",
	"./csv-download.svg": "446b",
	"./dashed-line.svg": "614b",
	"./discussion-selected.svg": "711b",
	"./edit-icon.svg": "60f4",
	"./exit.svg": "a789",
	"./file-icon-active-mobile.svg": "3fd2",
	"./file-icon-active.svg": "0073",
	"./file-icon-mobile.svg": "be5f",
	"./file-icon.svg": "a307",
	"./group-active-mobile.svg": "0c0e",
	"./group-active.svg": "8b58",
	"./group-mobile.svg": "b997",
	"./group.svg": "fb57",
	"./ic_calendar.png": "2afd",
	"./ic_location.png": "1025",
	"./ic_time.png": "5fa3",
	"./info.svg": "b6c6",
	"./paperclip.svg": "fa9f",
	"./profile-pic.svg": "b01b",
	"./program_added.svg": "94db",
	"./task-file-icon.svg": "3542",
	"./trash.svg": "d13b",
	"./various-items-active-mobile.svg": "6bff",
	"./various-items-active.svg": "06d3",
	"./various-items-mobile.svg": "1008",
	"./various-items.svg": "f1967"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ad7";